import React from "react";
import { FaTimes } from "react-icons/fa";

function ModalShell({ title, eyebrow, children, onClose, maxWidth = "max-w-3xl" }) {
  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-slate-950/70 p-3 backdrop-blur-sm sm:items-center sm:p-5">
      <button
        type="button"
        className="absolute inset-0"
        onClick={onClose}
        aria-label="Fermer la modale"
      />

      <div
        className={`relative max-h-[92dvh] w-full ${maxWidth} overflow-hidden rounded-t-[2rem] border border-white/10 bg-white shadow-2xl dark:bg-slate-950 sm:rounded-[2rem]`}
      >
        <div className="relative overflow-hidden border-b border-slate-200 bg-slate-950 p-5 text-white dark:border-white/10 sm:p-6">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(249,115,22,0.28),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(37,99,235,0.25),transparent_32%)]" />

          <div className="relative flex items-start justify-between gap-4">
            <div>
              {eyebrow && (
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-200">
                  {eyebrow}
                </p>
              )}

              <h2 className="mt-2 font-titre text-2xl font-bold leading-tight sm:text-3xl">
                {title}
              </h2>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-slate-950 shadow-lg transition hover:scale-105 active:scale-95"
              aria-label="Fermer"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="max-h-[calc(92dvh-112px)] overflow-y-auto p-5 sm:p-6">
          {children}
        </div>
      </div>
    </div>
  );
}

export default ModalShell;